export const BASE_URL = 'https://uat.definiteassurance.com/api';
